<template>
  <div>
    <toolbar />
    <zlick-navigation />
    <v-container>
      <v-layout row wrap center>
        <v-flex xs12 offset-xs0>
          <v-form ref="changePassword" v-model="valid" lazy-validation>
            <v-text-field
              :label="$t('current_password')"
              type="password"
              name="currentPassword"
              placeholder=""
              v-model="currentPassword"
              :rules="PasswordRules"
              autocomplete="off"
              validate-on-blur
              required
            />
            <v-text-field
              :label="$t('new_password')"
              type="password"
              name="newPassword"
              placeholder=""
              v-model="newPassword"
              :rules="PasswordRules"
              autocomplete="off"
              validate-on-blur
              required
            />
            <v-text-field
              :label="$t('confirm_password')"
              type="password"
              name="newPassword"
              placeholder=""
              :rules="MatchingPasswords"
              v-model="newPassword2"
              autocomplete="off"
              validate-on-blur
              required
            />
            <v-btn :disabled="!valid" @click="submit">{{ $t("submit") }}</v-btn>
            <v-btn @click="clear">{{ $t("cancel") }}</v-btn>
            <br />
            <br />
            <h3 v-if="error" class="text-xs-center">{{ error }}</h3>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Bugsnag from '../services/Bugsnag'
import AuthenticationService from '../services/AuthenticationService'
import Toolbar from './Toolbar'
import ZlickNavigation from './ZlickNavigation'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data () {
    return {
      valid: true,
      currentPassword: '',
      newPassword2: '',
      newPassword: '',
      error: null,
      PasswordRules: [
        v => !!v || this.$t('password_required'),
        v =>
          v.length > 7 ||
          this.$t('password_requirements', { length: 8, numbers: 1 })
      ],
      MatchingPasswords: [
        v => !!v || this.$t('password_required'),
        v =>
          v.length > 7 ||
          this.$t('password_requirements', { length: 8, numbers: 1 }),
        v => v === this.newPassword || this.$t('password_not_match')
      ]
    }
  },
  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
    }
  },
  methods: {
    clear () {
      this.currentPassword = ''
      this.newPassword2 = ''
      this.newPassword = ''
    },
    async submit () {
      if (!this.$refs.changePassword.validate()) return
      try {
        const loginResponse = await AuthenticationService.changePassword({
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        })
        if (loginResponse === 'success') {
          this.error = 'Password changed!'
          this.clear()
          return
        }
      } catch (error) {
        this.error = error.message
        Bugsnag.send(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue